import React from 'react'
import "./css/common.css"

export default function GuideTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        GUIDE
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
